/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { Filter, Id, useCondition, Workplace, WorkplaceProps } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';

export const BOWorkplace = <
    TableType extends Id<string | number>,
    ItemType extends Id<string | number> = TableType,
    FilterType extends Filter<any> = Filter<TableType>,
    ChangeRequestType = ItemType,
    AddRequestType = ItemType,
    DeleteRequestType = string | number,
>(
    props: Omit<
        WorkplaceProps<
            TableType,
            ItemType,
            FilterType,
            ChangeRequestType,
            AddRequestType,
            DeleteRequestType
        >,
        'dateTimeFormat' | 'settings'
    >
) => {
    const { dateTimeFormat } = useGeneralSettingsContext();
    const { settings, designType } = useGeneralSettingsContext();

    const defaultPageSize = useCondition(designType, { nova: 25 }, 10);
    return (
        <Workplace<
            TableType,
            ItemType,
            FilterType,
            ChangeRequestType,
            AddRequestType,
            DeleteRequestType
        >
            {...props}
            dateTimeFormat={dateTimeFormat}
            settings={settings}
            filterType={designType}
            workplaceType={designType}
            paginationType={designType}
            defaultPageSize={defaultPageSize}
        />
    );
};
